import containerFuild from '../html-snippets/container-fuild';
import buttonPrimary from '../../ui-modules/button-primary/raw-html';
import css from '../tpl-css/style-section-card-reviews-boxer.js';

const btnPrimary = buttonPrimary({
  align: 'center',
  text: 'TRY IT TODAY, RISK-FREE !',
});

const buildStars = (value, color) => {
  const stars = [];
  for (let i = 0; i < 5; i++) {
    const filled = i < value;
    stars.push(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="color: ${filled ? color : '#D9D9D9'};">
        <title>star</title>
        <path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" fill="currentColor" />
      </svg>
    `);
  }
  return stars.join('');
};

const verifiedSvg = `
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_611_1903)">
      <path d="M9.9999 2.02539L11.6312 3.83789L13.9874 3.11289L14.5312 5.46914L16.8874 6.01289L16.1624 8.36914L17.9749 10.0004L16.1624 11.6316L16.8874 13.9879L14.5312 14.5316L13.9874 16.8879L11.6312 16.1629L9.9999 17.9754L8.36865 16.1629L6.0124 16.8879L5.46865 14.5316L3.1124 13.9879L3.8374 11.6316L2.0249 10.0004L3.8374 8.36914L3.1124 6.01289L5.46865 5.46914L6.0124 3.11289L8.36865 3.83789L9.9999 2.02539Z" fill="#42ADA4"></path>
      <path d="M13.8422 6.59375L8.91219 11.5238L6.88219 9.49375L5.86719 10.5087L8.91219 13.5538L14.8572 7.60875L13.8422 6.59375Z" fill="#E3F2FD"></path>
    </g>
    <defs>
      <clipPath id="clip0_611_1903">
        <rect width="20" height="20" fill="white"></rect>
      </clipPath>
    </defs>
  </svg>
`;

const defaultItems = [
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fee2c3dc3d0a213d7884.png',
    stars: 4,
    h3: '"My husband used to worry about small leaks."',
    p: '"Since switching to these boxers, he\'s much more confident and comfortable throughout the day."',
    reviewer: 'Sarah L.',
    showVerified: true,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fee61027151fff3f1911.png',
    stars: 5,
    h3: '"A game changer for daily comfort."',
    p: '"Soft, breathable, and the leak protection just works. I\'ve already ordered more."',
    reviewer: 'Michael B.',
    showVerified: true,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fee9b9dca206cd3ccf0e.png',
    stars: 5,
    h3: '"A game changer for daily comfort."',
    p: '"Soft, breathable, and the leak protection just works. I\'ve already ordered more."',
    reviewer: 'Michael B.',
    showVerified: true,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0feed9442991b79467654.png',
    stars: 5,
    h3: '"A game changer for daily comfort."',
    p: '"Soft, breathable, and the leak protection just works. I\'ve already ordered more."',
    reviewer: 'Michael B.',
    showVerified: true,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0ff5e320710d1685f7057.png',
    stars: 5,
    h3: '"A game changer for daily comfort."',
    p: '"Soft, breathable, and the leak protection just works. I\'ve already ordered more."',
    reviewer: 'Michael B.',
    showVerified: true,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fef516e18ecdb72538b8.png',
    stars: 5,
    h3: '"A game changer for daily comfort."',
    p: '"Soft, breathable, and the leak protection just works. I\'ve already ordered more."',
    reviewer: 'Michael B.',
    showVerified: true,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fef8a65e841a068ec1cd.png',
    stars: 5,
    h3: '"A game changer for daily comfort."',
    p: '"Soft, breathable, and the leak protection just works. I\'ve already ordered more."',
    reviewer: 'Michael B.',
    showVerified: true,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fefbfa04d0b4b24eb94d.png',
    stars: 5,
    h3: '"A game changer for daily comfort."',
    p: '"Soft, breathable, and the leak protection just works. I\'ve already ordered more."',
    reviewer: 'Michael B.',
    showVerified: true,
  },
];

const colorStarDefault = '#FFD700';

const itemsHtml = defaultItems
  .map(
    item => `
        <div class="swiper-slide">
          <div data-attribute="item" class="wrap-item">
            <div class="wrap-img">
              <img data-attribute="image-item" src="${item.image}" alt="">
            </div>
            <div class="wrap-content-item">
              <div class="wrap-top-content-item">
                <div data-attribute="stars-item" data-value="${item.stars}" class="stars">
                  ${buildStars(item.stars, colorStarDefault)}
                </div>
                <div data-attribute="comment-item" class="comment-item">
                  <h3>${item.h3}</h3>
                  <p>${item.p}</p>
                </div>
              </div>
              <div class="wrap-bottom-content-item">
                <div data-attribute="reviewer" class="reviewer">${item.reviewer}</div>
                <div data-attribute="verified" data-show="${
                  item.showVerified ? 'true' : 'false'
                }" class="block-verified" style="display: ${item.showVerified ? 'flex' : 'none'};">
                  ${verifiedSvg}
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      `,
  )
  .join('');

const html = `
<div data-use-custom-width="true" data-custom-width="1204" class="container" data-attribute="container-content" style="--custom-width: 1204px;">
  <div class="wrap-card">
    <div data-show="true" data-attribute="card-title" class="card-title">
      <h2 style="color: #606f99; text-align: center;">125K +</h2>
      <h2 style="text-align: center;">Happy Customers</h2>
    </div>
    <div class="section-swiper">
      <div class="swiper">
        <div data-attribute="list-item" data-color-star="${colorStarDefault}" data-col-per-view="4" data-space-between="16" class="swiper-wrapper" style="--color-star: ${colorStarDefault};">
          ${itemsHtml}
        </div>
      </div>
      <div class="wrap-button-swiper">
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div data-attribute="wrap-btn-dynamic-primary" class="wrap-btn-card-review">
      ${btnPrimary}
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#eff3fa',
});
